import { StandardEvents } from '@shopify/events';
class UnityCartCount extends HTMLElement {
  connectedCallback() { document.addEventListener(StandardEvents.cartLinesUpdate, this.updateCount); }
  disconnectedCallback() { document.removeEventListener(StandardEvents.cartLinesUpdate, this.updateCount); }
  updateCount = (event) => {
    event.promise?.then(({ cart }) => {
      if (cart?.totalQuantity !== undefined) this.textContent = String(cart.totalQuantity);
    }).catch(() => {});
  };
}
if (!customElements.get('unity-cart-count')) customElements.define('unity-cart-count', UnityCartCount);